import { useSelector } from 'react-redux';
import styles from './FlooringInstalliationMethods.module.css';
import herringboneThumb from './assets/h.jpg';
import verticalAshlarThumb from './assets/va.jpg';
import powerbondThumb from './assets/p.jpg';
import monolithicThumb from './assets/m.jpg';
import horizontalAshlarThumb from './assets/ha.jpg';
import quarterTurnThumb from './assets/qt.jpg';
import thirdStaggerThumb from './assets/random.jpg';
import plankThumb from './assets/Plank.jpg';

export default function FlooringInstalliationMethods({ selectedProduct, handleFloorProductInstall }) {
  const masterData = useSelector(s => s.visualizer.productDataBySeries) || {};
  const installData = masterData['9774'] || {}; // object keyed by name
  const activeSurface = useSelector(state => state.visualizer.activeSurface);
  const activeFlooringSeriesIds = useSelector(s => s.visualizer.activeFlooringSeriesIds);
  const appliedProducts = useSelector(state => state.visualizer.appliedProducts);
  const appliedProduct = appliedProducts?.[activeSurface?.location ?? 'chamViz']?.[activeSurface?.name] ?? null;

  const currentInstallMethods = selectedProduct? selectedProduct.displayName.split(',').map(m => m.trim()): [];


  console.log('currentInstallMethods',currentInstallMethods)

  if (!selectedProduct || !activeFlooringSeriesIds.includes(selectedProduct.seriesID)) {
    return <p>Please select a product in this category to see install methods.</p>;
  }

  const getThumb = (name) => {
    const n = (name || '').toLowerCase();
    if (n.includes('herringbone')) return herringboneThumb;
    if (n.includes('horizontal') && n.includes('ashlar')) return horizontalAshlarThumb;
    if (n.includes('ashlar')) return verticalAshlarThumb;
    if (n.includes('powerbond')) return powerbondThumb;
    if (n.includes('monolithic')) return monolithicThumb;
    if (n.includes('quarter')) return quarterTurnThumb;
    if (n.includes('third') || n.includes('stagger')) return thirdStaggerThumb;
    if (n.includes('plank')) return plankThumb;
    return "#";
  };

  const installOptions = Object.entries(installData)
  .filter(([installName, obj]) => currentInstallMethods.includes(obj.sku))
  .map(([installName, obj]) => {
    const isActive = appliedProduct.install == obj.id;
    if(obj.name == 'test')
        return;

    return (
      <div
        key={obj.id}
        className={`${styles.installation} ${isActive ? styles.selected : ''}`}
        data-id={obj.id}
        data-size=''
        onClick={() => handleFloorProductInstall(obj.id)}
      >
        <img width={125} src={getThumb(obj.name)} alt={obj.name || installName} />
        <span>{obj.name}</span>
      </div>
    );
  });

  if (installOptions.length === 0) {
    return <p>No install methods found for this product.</p>;
  }

  return <div className={styles.patternDiv}><div className={styles.innerDiv}>{installOptions}</div></div>;
}
